import axios from "axios";

const { REACT_APP_BASE_URL } = process.env;

export const createDebt = async (token, propertyId, data) => {
  const body = {
    debt: {
      propertyRef: propertyId,
      detail: data.text ?? "",
      amount: Number(data.amount),
      type: data.type
    }
  };

  try {
    const response = await axios.post(`${REACT_APP_BASE_URL}/debts`, body, {
      headers: { Authorization: `Bearer ${token}` }
    });

    return response.data;
  } catch (error) {
    const err = error?.response?.data?.error ?? {};
    const response =
      err?.type === "VALIDATION_ERROR"
        ? err?.errors[0]?.msg
        : err.message ?? "Error en la petición";

    return Promise.reject(response);
  }
};
